import { render } from "./CreatePICKUP.vue?vue&type=template&id=4a60bf8c"
import script from "./CreatePICKUP.vue?vue&type=script&lang=js"
export * from "./CreatePICKUP.vue?vue&type=script&lang=js"

import "./CreatePICKUP.vue?vue&type=style&index=0&id=4a60bf8c&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__